import { Loader2 } from 'lucide-react'
import { Navigate } from 'react-router'
import { useCurrentOrganization } from '@/shared/hooks/api/organization'

type PackagingSuppliersRouteProps = {
  children: React.ReactNode
}

export function PackagingSuppliersRoute({
  children,
}: PackagingSuppliersRouteProps) {
  const { data: organization, isFetched } = useCurrentOrganization()

  if (!isFetched) {
    return (
      <div className='flex min-h-svh items-center justify-center'>
        <Loader2 className='size-8 animate-spin text-muted-foreground' />
      </div>
    )
  }

  if (organization?.packagingSuppliersEnabled !== true) {
    return <Navigate to='/product-catalog' replace />
  }

  return <>{children}</>
}
